import { render, staticRenderFns } from "./BizAiIcon.vue?vue&type=template&id=732ef287&scoped=true"
import script from "./BizAiIcon.vue?vue&type=script&lang=js"
export * from "./BizAiIcon.vue?vue&type=script&lang=js"
import style0 from "./BizAiIcon.vue?vue&type=style&index=0&id=732ef287&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732ef287",
  null
  
)

export default component.exports